import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllC_ST_RA_ParticipationType = createAsyncThunk(
  "SC_ST_RA_ParticipationType/GetAllC_ST_RA_ParticipationType",
  async (parameters, { rejectWithValue }) => {
    try {
  
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_ST_RA_ParticipationType/GetAllC_ST_RA_ParticipationType",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const SC_ST_RA_ParticipationType = createSlice({
  name: "SC_ST_RA_ParticipationType",
  initialState: {
    //------------- GetSC_ST_RA_ParticipationType ---------------------
    SC_ST_RA_ParticipationTypeList: [],
    loadingSC_ST_RA_ParticipationTypeList: false,
    errorSC_ST_RA_ParticipationTypeList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllC_ST_RA_ParticipationType.pending, (state, action) => {
        state.loadingSC_ST_RA_ParticipationTypeList = true;
        state.SC_ST_RA_ParticipationTypeList = action.payload;
        state.errorSC_ST_RA_ParticipationTypeList = null;
      })
      .addCase(GetAllC_ST_RA_ParticipationType.fulfilled, (state, action) => {
        state.loadingSC_ST_RA_ParticipationTypeList = false;
        state.SC_ST_RA_ParticipationTypeList = action.payload;
      })
      .addCase(GetAllC_ST_RA_ParticipationType.rejected, (state, action) => {
        state.loadingSC_ST_RA_ParticipationTypeList = false;
        state.SC_ST_RA_ParticipationTypeList = action.payload;
      });
  },
});

export default SC_ST_RA_ParticipationType.reducer;
